// GET Access Control
export const FETCH_ACCESSCONTROL_REQUEST = "FETCH_ACCESSCONTROL_REQUEST";
export const FETCH_ACCESSCONTROL_SUCCESS = "FETCH_ACCESSCONTROL_SUCCESS";
export const FETCH_ACCESSCONTROL_FAILURE = "FETCH_ACCESSCONTROL_FAILURE";

// POST data source
export const POST_DATASOURCE_REQUEST = "POST_DATASOURCE_REQUEST";
export const POST_DATASOURCE_SUCCESS = "POST_DATASOURCE_SUCCESS";
export const POST_DATASOURCE_FAILURE = "POST_DATASOURCE_FAILURE";

// PUT data source
export const PUT_DATASOURCE_REQUEST = "PUT_DATASOURCE_REQUEST";
export const PUT_DATASOURCE_SUCCESS = "PUT_DATASOURCE_SUCCESS";
export const PUT_DATASOURCE_FAILURE = "PUT_DATASOURCE_FAILURE";

// GET data source
export const FETCH_SOURCES_LIST_REQUEST = "FETCH_SOURCES_LIST_REQUEST";
export const FETCH_SOURCES_LIST_SUCCESS = "FETCH_SOURCES_LIST_SUCCESS";
export const FETCH_SOURCES_LIST_FAILURE = "FETCH_SOURCES_LIST_FAILURE";

export const FETCH_SOURCE_REQUEST = "FETCH_SOURCE_REQUEST";
export const FETCH_SOURCE_SUCCESS = "FETCH_SOURCE_SUCCESS";
export const FETCH_SOURCE_FAILURE = "FETCH_SOURCE_FAILURE";

// DELETE data source
export const DELETE_SOURCE_REQUEST = "DELETE_SOURCE_REQUEST";
export const DELETE_SOURCE_SUCCESS = "DELETE_SOURCE_SUCCESS";
export const DELETE_SOURCE_FAILURE = "DELETE_SOURCE_FAILURE";

// POST test connection
export const POST_CONNECTION_REQUEST = "POST_CONNECTION_REQUEST";
export const POST_CONNECTION_SUCCESS = "POST_CONNECTION_SUCCESS";
export const POST_CONNECTION_FAILURE = "POST_CONNECTION_FAILURE";
export const POST_CONNECTION_RESET = "POST_CONNECTION_RESET";

// GET user: data stewards
export const FETCH_STEWARD_REQUEST = "FETCH_STEWARD_REQUEST";
export const FETCH_STEWARD_SUCCESS = "FETCH_STEWARD_SUCCESS";
export const FETCH_STEWARD_FAILURE = "FETCH_STEWARD_FAILURE";